<template>
  <div class="animated fadeIn" id="list-decomptes-inval-dc">
    <a href="#" class="clickable" @click.prevent="exportAllDecomptes">
      Exporter l'intégralité des résultats au format csv
    </a>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
      <div slot="date_chargement" style="padding-top: 0.75em" slot-scope="props" class="slot-date formatted-box">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_chargement) }}</span>
      </div>

      <div slot="date_edition" style="padding-top: 0.75em" slot-scope="props" class="slot-date formatted-box">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_ed_decompte) }}</span>
      </div>

      <div slot="date_paiement" style="padding-top: 0.75em" slot-scope="props" class="slot-date formatted-box">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_em_pai) }}</span>
      </div>
      <div slot="site_affiliation" slot-scope="props" class="formatted-box">
        {{ props.row.rs_pm_site }} <br>
        <span style="color: #2139ff;">{{ props.row.siret_pm_site.substring(0, 9) }}</span>
        - <span style="color: #F96706">{{ props.row.siret_pm_site.substring(props.row.siret_pm_site.length - 5)
        }}</span>
      </div>
      <div slot="num_decompte" slot-scope="props" class="formatted-box">
        {{ props.row.num_decompte }}<br>
        <span style="color: #F96706">{{ props.row.produit}} </span>
        <i>({{ props.row.libelle_type_produit }})</i>
      </div>
      <div slot="nature" slot-scope="props" class="formatted-box">
        <i>{{ getNatureDecompte(props.row.tot_payer)}}</i><br>
        <span v-if="props.row.tot_payer > 0"><b>+</b></span>
        <span v-if="props.row.tot_payer < 0" style="color:#ce0b35"><b>{{ replaceDotToComma(formatNumber(props.row.tot_payer)) }} €</b></span>
        <span v-else><b>{{ replaceDotToComma(formatNumber(props.row.tot_payer)) }} €</b></span>
      </div>
      <div slot="num_ctr" slot-scope="props" class="formatted-box">
        {{ props.row.num_ctr }}<br>
        {{ props.row.nb_assure }}
      </div>
      <div slot="action" slot-scope="props" class="formatted-box">
        <i class="fa fa-search clickable text-primary mr-2" @click="AfficherPeriodes(props.row.id)"></i>
        <img style="width: 15px;" class="mr-2 clickable" :src="getIcon('xls')" @click="generateExcelDecompte(props.row.id)">
        <img style="width: 15px;" class="mr-2 clickable"  v-b-tooltip.hover title="PDF CHORUM" :src="getIcon('pdf')" @click="generatePDFFromDecomptes(props.row.num_decompte, props.row.id)">
        <i v-if="isNotArchive(props.row, 'decompte')" v-b-tooltip.hover title="Archiver" class="fa fa-folder clickable text-warning" @click="updateStatus('decompte', 'archive', props.row.id)"></i>
        <i v-else v-b-tooltip.hover title="Désarchiver" class="fa fa-folder-open clickable text-secondary" @click="updateStatus('decompte', 'a_traiter', props.row.id)"></i>
        <span v-if="hasRule(rules.CAN_DOWNLOAD_DECOMPTE_MUTEX) && (checkDateDispoMutex(props.row.date_em_pai))"> - <img  style="width: 15px;" class="mr-2 clickable"  v-b-tooltip.hover title="PDF MUTEX" :src="getIcon('pdf')" @click="generatePDFMutexFromDecomptes(props.row.num_decompte, props.row.id)"></span>
        <br>
        <span style="font-size: 13px"><i>{{ props.row.statut }}</i></span>
      </div>
      <div slot="selection" slot-scope="props" class="formatted-box">
        <b-form-checkbox v-model="selectedRows_1" :value="props.row.id" :state="errors.checkbox_1 === ''"></b-form-checkbox>
      </div>
      <div slot="h__selection">
        <b-form-checkbox
          v-model="allSelected_1"
          :indeterminate="indeterminate_1"
          aria-describedby="items"
          aria-controls="items"
          @change="toggleAll">
        </b-form-checkbox>
      </div>
    </v-server-table>
    <b-row>
      <b-col md="9"></b-col>
      <b-col md="3" style="display: inline-flex;flex-direction: row">
        <b-form-group  label-for="action_1" class="mr-2" style="order: 0;flex-grow: 1;height:15px;">
          <b-form-select
            id="action_1"
            :plain="true"
            :options="action_1_options"
            v-model="selectedOption1">
          </b-form-select>
        </b-form-group>
        <button type="button" style="order: 1;" class="btn btn-primary" @click="triggerAction">OK</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {formatDate, formatNumber, replaceDotToComma} from "@/utils/communHelper";
  import {isEmpty, getFileIcon} from "@/utils/fileHelper";
  import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";

  export default {
    name: "DecomptesTable",
    props: ["tableEntry"],
    data() {
      let self = this;
      return {
        url: '',
        hasRule,
        rules,
        decomptes: [],
        allSelected_1: false,
        selectedRows_1: [],
        indeterminate_1: false,
        action_1_options: [
          {value: 'null', text: 'Action sur la séléction'},
          {value: 'neutralise', text: 'Neutraliser'},
          {value: 'en_attente', text: 'En attente'},
          {value: 'a_verifier', text: 'A vérifier'},
          {value: 'a_traiter', text: 'A traiter'},
          {value: 'afficher_periodes', text: 'Afficher les périodes'},
          {value: 'export_csv', text: 'Export CSV'},
        ],
        selectedOption1: null,
        columns: [
          'date_chargement',
          'date_edition',
          'date_paiement',
          'site_affiliation',
          'num_decompte',
          'nature',
          'num_ctr',
          'action',
          'selection'
        ],
        items: [],
        searchData: [],
        excelData: [],
        options: {
          headings: {
            'date_paiement': 'Date de paiement',
            'date_chargement': 'Date de chargement',
            'date_edition': "Date \nédition",
            'site_affiliation': "Site d'affiliation\nSIREN - NIC",
            'num_decompte': 'N° décompte\nProduit (type)',
            'nature': 'Nature \nMontant',
            'num_ctr': 'N° Contrat \nNb assurés',
            'action': 'Action\nStatut',
            'selection': '',
          },
          columnsClasses: {
            date_chargement: 'pre-formatted sort-top text-center position-r date-col text-wrap',
            date_edition: 'pre-formatted sort-top text-center position-r date-col text-wrap',
            date_paiement: 'pre-formatted sort-top text-center position-r date-col text-wrap',
            site_affiliation: 'pre-formatted sort-top position-r text-center',
            num_decompte: 'pre-formatted sort-top position-r text-center',
            nature: 'pre-formatted sort-top position-r text-center',
            num_ctr: 'pre-formatted sort-top position-r text-center',
            action: 'pre-formatted sort-top text-center position-r',
            selection: 'pre-formatted align-middle text-center sort-top position-r',
          },
          perPage: 25,
          perPageValues: [25, 50, 100],
          sortable: ["date_paiement", "date_chargement", "date_edition"],
          orderBy: {column: 'date_paiement', ascending: false },
          filterable: false,
          requestFunction: function (data) {
            self.url = '/espaceGestion/decomptesIJ/search';
            data["numero_decompte"] = self.tableEntry.numero_decompte;
            data["montant_decompte"] = self.tableEntry.montant_decompte;
            data["type_decompte"] = self.tableEntry.type_decompte;
            data["statut_decompte"] = self.tableEntry.statut_decompte;
            data["date_debut_decompte"] = self.tableEntry.date_debut_decompte;
            data["date_fin_decompte"] = self.tableEntry.date_fin_decompte;
            data["date_chargement_debut_decompte"] = self.tableEntry.date_chargement_debut_decompte;
            data["date_chargement_fin_decompte"] = self.tableEntry.date_chargement_fin_decompte;
            data["siren"] = self.tableEntry.siren;
            data["nic"] = self.tableEntry.nic;
            data["raison_sociale"] = self.tableEntry.raison_sociale;
            data["numero_contrat"] = self.tableEntry.numero_contrat;
            data["famille_produit"] = self.tableEntry.famille_produit;
            data["nom_cev"] = self.tableEntry.nom_cev;
            data["prenom_cev"] = self.tableEntry.prenom_cev;
            data["email_cev"] = self.tableEntry.email_cev;
            data['noSearch'] = self.$parent.noSearch;
            data["nom_salarie"] = null;
            data["prenom_salarie"] = null;
            data["nir_salarie"] = null;
            //data['forExport'] = false;
            if (self.tableEntry.noSearch !== 'noSearch') {
              self.$store.commit('IS_LOADING', true);
            }
            return axios.get(self.url, {params: data})
              .then(function (response) {
                if (self.tableEntry.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.decomptes = response.data.data;
                self.searchData = data;
                self.excelData = [];
                return response;
              })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          }
        },
        formatDate,
        formatNumber,
        replaceDotToComma,
        isEmpty,
        errors: {
          checkbox_1: '',
        },
      };
    },
    watch: {
     selectedRows_1(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate_1 = false
          this.allSelected_1 = false
        } else if (newVal.length === this.$refs.table.data.length) {
          this.indeterminate_1 = false
          this.allSelected_1 = true
        } else {
          this.indeterminate_1 = true
          this.allSelected_1 = false
        }
      },
    },
    methods: {
      onLoaded(){
        this.$store.commit("IS_LOADING", false);
      },
      toggleAll(checked) {
        this.selectedRows_1 = checked ? this.$refs.table.data.map(item => item.id) : [];
      },
      getNatureDecompte(montant) {
        let nature = 'Pour info';
        if (montant > 0) {
          nature = 'Versement';
        } else if (montant < 0) {
          nature = 'Débit restant';
        }
        return nature;
      },
      getIcon(extension) {
        let images = require.context('../../../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/);
        let extensionIcon = getFileIcon();
        return images('./' + extensionIcon[extension]);
      },
      generateExcelDecompte(decompte_id) {
        const decomptes_ids = !isEmpty(decompte_id) ? [decompte_id] : [];
        if(decomptes_ids.length > 0) {
          this.$emit('actions-from-decomptes', { action: 'export_csv', rows: decomptes_ids });
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !',
            text: 'Vous devez au moins cocher un décompte',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      triggerAction() {
        this.$emit('actions-from-decomptes', { action: this.selectedOption1, rows: this.selectedRows_1 });
      },
      exportAllDecomptes() {
        if (this.searchData.length !== 0) {
          this.$emit('export-all-decomptes', { search_data: this.searchData, data: this.$refs['table'].data });
        }
      },
      AfficherPeriodes(decompte_id) {
        this.$store.commit("IS_LOADING", true);
        this.$emit('afficher-prestations-from-decomptes', { decompte_id: decompte_id });
      },
      isNotArchive(decompte, type) {
        let decompteStatus = null;
        if (type === 'prestation') {
          // Certain presta_statut_id ne sont pas renseignés si on tombe sur un de ces cas, on prend le statut du décompte
          if (isEmpty(decompte.presta_statut_id)) {
            decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
          } else {
            decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.presta_statut_id,10));
          }
        } else {
          decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
        }
        return  (!(decompteStatus && decompteStatus.libelle_technique === 'archive'));
      },
      generatePDFFromDecomptes(numero_decompte, decompte_id) {
        this.$emit('generate-pdf-from-decomptes', { numero_decompte: numero_decompte, decompte_id: decompte_id });
      },
      generatePDFMutexFromDecomptes(numero_decompte, decompte_id) {
        this.$emit('generate-pdf-mutex-from-decomptes', { numero_decompte: numero_decompte, decompte_id: decompte_id });
      },
      updateStatus(type, statut_libelle_technique, ids) {
        this.$emit('update-status-from-decomptes', { type: type, statut_libelle_technique: statut_libelle_technique, ids: ids });
      },
      checkDateDispoMutex(dateDecompte){
        let dateDecompteTime = new Date(dateDecompte).getTime();
        let dateJour = new Date();
        dateJour.setDate(dateJour.getDate()-1);
        let dateCompare = dateJour.getTime();
        return dateDecompteTime <= dateCompare;
      }
    }
  };
</script>
<style>
  .formatted-box {
    white-space: nowrap !important;
    max-width: 100% !important;
  }
  tr.VueTables__row td {
    line-height: 25px;
    padding: 0 0.75rem;
  }

  .IZ-select__input input {
    font-size: 0.9rem;
  }

  .hasError {
    border-radius: 5px;
  }

  .bg-white {
    background-color: #FFFFFF;
  }

  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }

  tr td.tooltip-cell {
    padding: 0;
  }

  tr td.tooltip-cell > div span {
    display: inline-block;
    width: 100%;
    padding: 0 0 0 0.75rem;
  }

  .ul-tooltip {
    padding: 0;
    list-style: none;
  }

  .green {
    color: #28a745;
  }

  .VueTables__sort-icon {
    float: none;
    position: absolute;
    right: 0.25rem;
  }

  .sort-top .VueTables__sort-icon {
    top: 0.75rem;
  }

  .sort-bottom .VueTables__sort-icon {
    bottom: 0.75rem;
  }

  .sort-middle .VueTables__sort-icon {
    bottom: 40%;
  }

  .min-width-nir {
    min-width: 175px;
  }

  .btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
  }


  #list-decomptes-inval-dc .VueTables__table thead tr th:nth-child(1),
  #list-decomptes-inval-dc .VueTables__table thead tr th:nth-child(2),
  #list-decomptes-inval-dc .VueTables__table thead tr th:nth-child(3) {
    width: 6%;
  }
</style>
